import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'removeBracketsContent'
})
export class RemoveBracketsContentPipe implements PipeTransform {

    /* brackets content removing */
    transform(value: string): any {
        if (value) {
            const searchBracketsContent = value.search(/[ ]?\[/g); // search for content starting with '['
            if (searchBracketsContent !== -1) {
                return value.substring(0, searchBracketsContent);
            } else {
                return value;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/remove-brackets-content.pipe.ts